/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCorrectNextExam200,
  GetApiV1ExamCorrectNextExam400,
  GetApiV1ExamCorrectNextExam401,
  GetApiV1ExamCorrectNextExam500,
  GetApiV1ExamCorrectNextExamQueryParams,
  GetApiV1ExamCorrectNextExamQueryResponse,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectNextExam.ts";
import { examItemAnswerTextCorrectionViewModelSchema } from "../examItemAnswerTextCorrectionViewModelSchema.ts";

export const getApiV1ExamCorrectNextExamQueryParamsSchema = z
  .object({
    examPublishId: z.optional(z.coerce.number().int()),
    examItemId: z.optional(z.coerce.number().int()),
    lastAnswerId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamCorrectNextExamQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCorrectNextExam200Schema = z.lazy(
  () => examItemAnswerTextCorrectionViewModelSchema,
) as unknown as ToZod<GetApiV1ExamCorrectNextExam200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCorrectNextExam400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectNextExam400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCorrectNextExam401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectNextExam401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCorrectNextExam500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectNextExam500>;

export const getApiV1ExamCorrectNextExamQueryResponseSchema = z.lazy(
  () => getApiV1ExamCorrectNextExam200Schema,
) as unknown as ToZod<GetApiV1ExamCorrectNextExamQueryResponse>;
